import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

export default function CommentBubble({ theme, ...props }) {
  return (
    <svg
      aria-labelledby={props.ariaTags.labelledBy}
      aria-hidden={props.ariaTags.hidden}
      className={cx(theme.container, theme[props.svg], props.className)}
      tabIndex={props.tabIndex}
      viewBox="0 0 18 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className={theme.fill}
        d="M15.63 2.99997C15.7225 3.00189 15.8111 3.0375 15.8792 3.1001C15.9473 3.16269 15.9903 3.248 16 3.34V11.03C15.9903 11.122 15.9473 11.2073 15.8792 11.2699C15.8111 11.3325 15.7225 11.3681 15.63 11.37H10.42C10.095 11.37 9.77487 11.4492 9.48737 11.6008C9.19986 11.7524 8.95362 11.9718 8.76999 12.24L7.91998 13.48L7.06 12.24C6.87732 11.9732 6.63267 11.7547 6.34705 11.6032C6.06142 11.4517 5.74331 11.3716 5.41998 11.37H2.35999C2.26787 11.3701 2.17921 11.3349 2.11224 11.2717C2.04528 11.2085 2.00512 11.1219 2 11.03V3.32999C2.00512 3.23802 2.04528 3.1515 2.11224 3.08826C2.17921 3.02501 2.26787 2.98985 2.35999 2.98999H15.63V2.99997ZM15.63 0.98999H2.35999C1.74433 0.989791 1.15297 1.23016 0.712067 1.65985C0.271166 2.08954 0.0156522 2.67452 0 3.28998V11.07C0.0156522 11.6854 0.271166 12.2704 0.712067 12.7001C1.15297 13.1298 1.74433 13.3702 2.35999 13.37H5.41998L7.91998 17L10.42 13.37H15.63C16.2466 13.3703 16.8391 13.1302 17.2816 12.7007C17.7241 12.2713 17.9818 11.6863 18 11.07V3.29999C17.9818 2.68364 17.7241 2.09865 17.2816 1.66922C16.8391 1.23979 16.2466 0.999701 15.63 0.99997V0.98999Z"
      />
    </svg>
  )
}

CommentBubble.propTypes = {
  ariaTags: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  svg: PropTypes.string.isRequired,
  theme: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  className: PropTypes.string,
  tabIndex: PropTypes.string,
}
